import { render, staticRenderFns } from "./CaseNumSum.vue?vue&type=template&id=2c47c9d0&scoped=true"
import script from "./CaseNumSum.vue?vue&type=script&lang=js"
export * from "./CaseNumSum.vue?vue&type=script&lang=js"
import style0 from "./CaseNumSum.vue?vue&type=style&index=0&id=2c47c9d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47c9d0",
  null
  
)

export default component.exports